(() => {
  const groups = {
    map: '(title:map OR (title:australia title:road title:trip))',
    clock: '(title:clock OR (title:months title:days title:time))',
    humanbody: '(title:human (title:body OR title:skeleton))'
  };
  const titleWords = ["100", "12", "25", "29", "35", "3d", "abstract", "add", "adventure", "affirmations", "all", "aloha", "alphabet", "anchor", "and", "arch", "arches", "are", "australia", "australian", "baby", "balls", "basketball", "batman", "be", "beach", "bed", "bedhead", "bells", "best", "birth", "block", "body", "boho", "border", "borders", "bow", "building", "bunnies", "butterflies", "butterfly", "camper", "caravan", "card", "chart", "checkers", "child", "christmas", "circle", "collage", "colour", "colours", "control", "cool", "coquettish", "corner", "court", "creatures", "cricket", "cursive", "custom", "customisable", "cut", "day", "days", "decal", "decals", "detailed", "dinosaur", "dinosaurs", "dot", "dots", "down", "drawn", "dream", "eh", "emoji", "emotions", "etc", "eucalyptus", "family", "flash", "flower", "flowers", "font", "for", "free", "fridge", "gallery", "gift", "grateful", "green", "grid", "half", "hand", "head", "heart", "height", "here", "holden", "home", "horse", "human", "individual", "is", "it", "jingle", "kids", "kind", "kombi", "large", "leaves", "letters", "life", "lives", "loopy", "love", "manifesto", "mantras", "map", "masks", "medium", "memories", "mermaid", "mermaids", "merry", "mindfulness", "mini", "minimalist", "mix", "mixed", "months", "motto", "muscles", "name", "netball", "noel", "numbers", "of", "on", "out", "outdoor", "outline", "own", "pack", "packs", "palm", "park", "patterns", "peace", "perfect", "periodic", "personalise", "personalised", "photo", "picnic", "pink", "play", "plunging", "positive", "poster", "pray", "preset", "quote", "quotes", "rainbow", "rectangles", "retro", "road", "robin", "ruler", "rules", "salt", "salty", "sand", "saving", "scallop", "sea", "set", "sets", "several", "shack", "shape", "shapes", "shasta", "shells", "sherrin", "single", "singles", "sizes", "skeleton", "skeletons", "sleep", "small", "soccer", "solar", "spilling", "sports", "spots", "square", "squares", "stars", "stay", "straight", "strawberry", "stripes", "strips", "sun", "super", "superhero", "surf", "surfboard", "system", "table", "tasmania", "tennis", "test", "text", "the", "these", "this", "time", "times", "to", "tree", "tricolour", "trip", "tripping", "tropics", "trucks", "true", "under", "us", "use", "van", "vintage", "vinyl", "wagon", "wall", "wallaby", "wallpaper", "wandering", "watercolour", "wave", "ways", "we", "what", "where", "while", "with", "wombats", "wonder", "wonderful", "wondermade", "word", "world", "worm", "your"];
  const stopwords = new Set(['a', 'an', 'and', 'are', 'at', 'be', 'by', 'for', 'from', 'in', 'is', 'it', 'of', 'on', 'or', 'the', 'to', 'with', 'your', 'this', 'these', 'those', 'that', 'while', 'we', 'our', 'out', 'own']);
  const aliases = [
    [/\b(?:timestables?|multiplication(?:\s+(?:tables?|charts?))?)\b/g, 'times table'],
    [/\b(?:abc|a\s*[-–]\s*z)\b/g, 'alphabet'],
    [/\b(?:how are you feeling|feelings?)\b/g, 'emotions'],
    [/\bcounting\b/g, 'numbers'],
    [/\bhuman body\b/g, 'humanbody'],
    [/\b(?:refrigerators?|fridges?)(?:\s+(?:wraps?|stickers?|decals?))?\b/g, 'fridge'],
    [/\bcustom\s+photos?\b/g, 'photo'],
    [/\bphotos?\s+(?:wall\s+)?(?:stickers?|decals?)\b/g, 'photo'],
    [/\bphotos?\s+(?:circles?|rounds?)\b/g, 'photo dots'],
    [/\bwall\s+(?:stickers?|decals?)\b/g, 'decals'],
    [/\bstickers?\b/g, 'decal'],
    [/\bmaps\b/g, 'map'],
    [/\bclocks\b/g, 'clock'],
    [/\bcolou?rs\b/g, 'colours'],
    [/\bcolou?r\b/g, 'colour'],
    [/\bpersonaliz/g, 'personalis'],
    [/\bcustomiz/g, 'customis']
  ];

  const excludeTestProducts = (query) => query.includes(' -title:test') ? query : `${query} -title:test`;

  const buildQuery = (value, prefix = false) => {
    const input = String(value || '').trim();
    if (!input) return input;
    if (/\btitle:/.test(input)) return excludeTestProducts(input);
    let query = input.normalize('NFKC').toLowerCase().replace(/['’]s\b/g, '');
    aliases.forEach(([pattern, replacement]) => { query = query.replace(pattern, replacement); });
    const words = query.match(/[\p{L}\p{N}]+(?:['’][\p{L}\p{N}]+)*/gu) || [];
    const terms = words.filter((word) => !stopwords.has(word));
    const searchable = terms.length ? terms : words;
    const result = searchable.map((word, index) => {
      if (groups[word]) return groups[word];
      if (index === searchable.length - 1 && word.length >= 2 && !titleWords.includes(word)) {
        const completions = [...new Set([...titleWords, 'clock'])].filter((candidate) => candidate.startsWith(word)).sort((a, b) => a.length - b.length).slice(0, 20);
        const first = completions[0];
        if (first && completions.every((candidate) => candidate === first || candidate === `${first}s` || candidate === `${first}es`)) return groups[first] || `title:${first}`;
        if (prefix && completions.length) return `(${[word, ...completions].map((candidate) => `title:${candidate}`).join(' OR ')})`;
      }
      return `title:${word}`;
    }).join(' ') || 'title:wmnomatchingsearchterm';
    return excludeTestProducts(result);
  };

  const buildURL = (value) => {
    const url = new URL(value, window.location.origin);
    const query = url.searchParams.get('q');
    if (query) url.searchParams.set('q', buildQuery(query));
    url.searchParams.set('options[prefix]', 'last');
    return url.pathname + url.search + url.hash;
  };

  const buildSuggestionURL = (value, term) => {
    const url = new URL(buildURL(value), window.location.origin);
    url.searchParams.set('q', buildQuery(term, true));
    url.searchParams.set('view', 'data');
    return url.pathname + url.search;
  };

  window.theme = window.theme || {};
  window.theme.posterSearch = { buildQuery, buildURL, buildSuggestionURL };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (new URL(form.action, window.location.origin).pathname.replace(/\/$/, '') !== window.theme.routes.search_url.replace(/\/$/, '')) return;
    const input = form.querySelector('[name="q"]');
    if (!input) return;
    const original = input.value;
    input.value = buildQuery(original);
    if (input.type !== 'hidden') window.setTimeout(() => { input.value = original; }, 0);
  }, true);

  const current = new URL(window.location.href);
  if (current.pathname.replace(/\/$/, '') === window.theme.routes.search_url.replace(/\/$/, '')) {
    const raw = current.searchParams.get('q') || '';
    const query = buildQuery(raw);
    if (query !== raw && !current.searchParams.has('view') && !current.searchParams.has('section_id')) {
      current.searchParams.set('q', query);
      current.searchParams.set('options[prefix]', 'last');
      current.searchParams.delete('page');
      window.location.replace(current.href);
    }
  }
})();
